import {
  usePlayer,
  usePlayers,
  useRound,
  useGame,
  useStage
} from "@empirica/core/player/classic/react";
import { Loading } from "@empirica/core/player/react";
import React from "react";
import { Introduction } from "./stages/Introduction";
import { Consent } from "./stages/Consent";
import { Tutorial } from "./stages/Tutorial";
import { MainTask } from "./stages/MainTask";
import { Break } from "./stages/Break";

export function Stage() {
  const player = usePlayer();
  const players = usePlayers();
  const round = useRound();
  const game = useGame();
  const stage = useStage();

  // Handle loading state
  if (!game || !round || !stage || !player || !player.stage) {
    return (
      <div className="h-full flex flex-col items-center justify-center">
        <Loading />
        <p className="text-center text-gray-400 mt-4">
          Loading game...
        </p>
      </div>
    );
  }

  // Check if we have all required players
  const treatment = game.get("treatment");
  const requiredPlayers = treatment?.playerCount || 2;
  
  if (players.length < requiredPlayers) {
    return (
      <div className="h-full flex flex-col items-center justify-center">
        <div className="text-center text-gray-400">
          <p className="text-lg">Waiting for other players...</p>
          <p className="mt-2">
            {players.length} of {requiredPlayers} players connected
          </p>
        </div>
      </div>
    );
  }

  // If stage is submitted
  if (player.stage.get("submit")) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="text-center text-gray-400">
          Waiting for other players to finish...
        </div>
      </div>
    );
  }

  // Render the appropriate stage content
  switch (round.get("task")) {
    case "consent":
      return <Consent />;
    case "introduction":
      return <Introduction />;
    case "tutorial":
      return <Tutorial stage={stage} />;
    case "perceptual":
      return <MainTask />;
    case "break":
      return <Break />;
    default:
      return (
        <div className="h-full flex items-center justify-center">
          <div className="text-center text-red-500">
            Unknown task type: {round.get("task")}
          </div>
        </div>
      );
  }
}
